import React from 'react';
import { Typography } from '@rentspree/component-2023.components.atoms.typography';

export interface SectionHeaderProps {
  title: string;
  description?: string | undefined;
  align?: 'left' | 'center' | 'right' | undefined;
  className?: string | undefined;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  description,
  align = 'left',
  className,
}) => (
  <div className={className} style={{ textAlign: align, marginBottom: 32 }}>
    <Typography
      variant='h5'
      sx={{
        fontWeight: 600,
        fontSize: '24px',
        color: '#212121',
        marginBottom: '8px',
      }}
    >
      {title}
    </Typography>
    {description && (
      <Typography variant='body2' color='textSecondary' sx={{ marginTop: 0.5 }}>
        {description}
      </Typography>
    )}
  </div>
);
